import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import cx from 'classnames';
import find from 'lodash/find';
import map from 'lodash/map';

import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import langmap from '@plone/volto/helpers/LanguageMap/LanguageMap';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { toReactIntlLang } from '@plone/volto/helpers/Utils/Utils';

import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  switchLanguageTo: {
    id: 'Switch to',
    defaultMessage: 'Switch to',
  },
});

const LanguageSelector = (props) => {
  const intl = useIntl();
  const location = useLocation();
  const currentLang = useSelector((state) => state.intl.locale);
  const translations = useSelector(
    (state) => state.content.data?.['@components']?.translations?.items,
  );

  const availableLanguages = ['en', 'de'];

  const [isHCoreDomain, setIsHCoreDomain] = React.useState(false);
  React.useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.location.hostname.endsWith('h-core.eu')
    ) {
      setIsHCoreDomain(true);
    }
  }, []);

  const currentPathSegments = location.pathname.split('/').filter(Boolean);

  return (
    <div className="language-selector">
      {map(availableLanguages, (lang) => {
        const translation = find(translations, { language: lang });
        const language =
          lang === 'en'
            ? 'EN'
            : lang === 'de'
              ? 'DE'
              : langmap[lang].nativeName;

        let target;
        if (isHCoreDomain) {
          const hasLangPrefix = availableLanguages.includes(
            currentPathSegments[0],
          );
          const remainingSegments = hasLangPrefix
            ? currentPathSegments.slice(1)
            : currentPathSegments;
          target = '/' + [lang, ...remainingSegments].join('/');
        } else {
          target = translation
            ? flattenToAppURL(translation['@id'])
            : `/${lang}`;
        }
        const ariaLabel = `${intl.formatMessage(
          messages.switchLanguageTo,
        )} ${langmap[lang].nativeName.toLowerCase()}`;
        const className = cx({
          selected: toReactIntlLang(lang) === currentLang,
        });

        if (isHCoreDomain) {
          return (
            <a
              aria-label={ariaLabel}
              className={className}
              href={target}
              title={langmap[lang].nativeName}
              onClick={() => {
                props.onClickAction();
              }}
              key={`language-selector-${lang}`}
            >
              {language}
            </a>
          );
        }

        return (
          <Link
            aria-label={ariaLabel}
            className={className}
            to={target}
            title={langmap[lang].nativeName}
            onClick={() => {
              props.onClickAction();
            }}
            key={`language-selector-${lang}`}
          >
            {language}
          </Link>
        );
      })}
    </div>
  );
};

LanguageSelector.propTypes = {
  onClickAction: PropTypes.func,
};

LanguageSelector.defaultProps = {
  onClickAction: () => {},
};

export default LanguageSelector;
